<template>
  <form @submit.prevent="onSubmit">
    <label for="name">
      <input
        id="name"
        v-model="name"
        required
        name="name"
        type="text"
        class="input type--name"
        :placeholder="'yourName' | localize"
      />
    </label>
    <label for="email">
      <input
        id="email"
        v-model="email"
        required
        name="email"
        type="text"
        class="input type--email"
        :placeholder="'yourPhone' | localize"
      />
    </label>
    <label for="message">
      <textarea
        id="message"
        v-model="message"
        required
        name="message"
        cols="30"
        rows="10"
        class="textarea type--message"
        :placeholder="'yourMessage' | localize"
      ></textarea>
    </label>
    <br />
    <transition name="fade">
      <div v-if="success">
        <br />
        <div class="dance-man__text">{{'messagseSendSuccess' | localize}}</div>
        <br />
        <img src="/img/dance.gif" style="border-radius: 50%;" alt="dance" />
      </div>
    </transition>
    <br />
    <div v-if="$route.path == '/ru'" class="condition">
      Нажимая кнопку "Отправить", вы соглашаетесь на обработку
      <a
        href="/document.pdf"
        target="_blank"
      >персональных данных и ознакомлены с политикой конфидециальности</a>
    </div>

    <button type="submit" class="btn-primary">{{'send' | localize}}</button>
  </form>
</template>

<script>
import axios from "axios";

export default {
  name: "Activities",
  props: {},
  data: () => ({
    email: "",
    name: "",
    message: "",
    success: false,
    sitekey: "6Le5QtoUAAAAAExiQWlJ9_x9PADlWbr2ZENShULp",
    widgetId: 0,
    token: "",
  }),
  methods: {
    async onSubmit() {
      var bodyFormData = new FormData();
      bodyFormData.set("name", this.name);
      bodyFormData.set("email", this.email);
      bodyFormData.set("message", this.message);
      bodyFormData.set("type", "contacts");
      bodyFormData.set("g-recaptcha-response", this.token);

      this.email = "";
      this.name = "";
      this.message = "";
      this.success = true;

      await axios({
        method: "post",
        url: "/api/index.php",
        data: bodyFormData,
        config: { headers: { "Content-Type": "multipart/form-data" } },
      })
        .then(function (response) {})
        .catch(function (response) {});

      setTimeout(() => {
        this.success = false;
      }, 5000);
    },
    execute() {
      grecaptcha.execute();
    },
    reset() {
      grecaptcha.reset();
    },
    recaptcha() {
      if (window.grecaptcha) {
        const self = this;

        grecaptcha.ready(function () {
          grecaptcha
            .execute(self.sitekey, {
              action: "homepage",
            })
            .then(function (token) {
              self.token = token;
            });
        });
      }
    },
  },
  mounted() {
    this.recaptcha();
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: transform 0.5s ease-in-out;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  transform: scale(0);
}

.dance-man__text {
  display: inline-block;
  border-radius: 10px;
  background: #f6fcff;
  font-weight: 600;
}

.condition {
  margin-bottom: 15px;
  font-size: 12px;
  font-style: italic;
  background: #fff;
}

.input {
  height: 60px;
  width: 313px;
  padding: 20px;
  font: 20px $font__primary;
  background-size: cover;

  @media (max-width: 989px) {
    height: 43px;
    width: 275px;
    font-size: 15px;
  }

  @media (min-width: 990px) and (max-width: 1199px) {
    height: 51px;
    width: 265px;
    font-size: 17px;
  }

  &.type--name {
    background-image: url(/img/contacts/name.svg);
    @media (max-width: 989px) {
      background-image: url(/img/mobile/contacts/name.svg);
    }
  }

  &.type--email {
    background-image: url(/img/contacts/email.svg);
    margin-top: 20px;

    @media (max-width: 989px) {
      background-image: url(/img/mobile/contacts/name.svg);
    }

    @media (min-width: 990px) and (max-width: 1199px) {
      margin-left: 15px;
    }
  }
}

.textarea {
  margin-top: 20px;
  resize: none;
  height: 208px;
  width: 630px;
  padding: 20px;
  font: 20px $font__primary;
  background-size: cover;
  background-image: url(/img/contacts/message.svg);

  @media (max-width: 989px) {
    height: 150px;
    font-size: 15px;
    width: 275px;
    background-image: url(/img/mobile/contacts/message.svg);
  }

  @media (min-width: 990px) and (max-width: 1199px) {
    height: 182px;
    width: 550px;
    font-size: 17px;
  }
}
</style>